import styled from '@emotion/styled';
import { theme } from '@pairy/styles';
import * as RadixTooltip from '@radix-ui/react-tooltip';

export const TooltipContent = styled(RadixTooltip.Content)`
  z-index: 500;
`;

export const ContentWrapper = styled.div`
  padding: 8px;

  background: ${theme.colors.zinc_500};
  border-radius: 4px;
  box-shadow: ${theme.elevation.md};
`;
